// extracted by mini-css-extract-plugin
export var aircallIframe = "_iv-3";
export var fabContainer = "_iv-5";
export var fabRinging = "_iv-6";
export var loadingOverlay = "_iv-4";
export var pulse = "_iv-7";
export var widgetContent = "_iv-2";
export var widgetPanel = "_iv-0";
export var widgetPanelExpanded = "_iv-1";